import React from 'react'
import { BaseCreating } from '../Create/Creating'
import { useIntl } from 'react-intl'

export function Creating() {
  const intl = useIntl()
  return (
    <BaseCreating
      text={intl.formatMessage({
        id: 'boarding.acceptInvitation.creating.text',
        defaultMessage: 'Creating your account...',
      })}
    />
  )
}
